export const key = {
RES_UID:'res_uid',
USER_DATA:'userData',
RES_NAME:'resname',
SEAT_ALLOCATED:'seat_allocated',
GUEST_PER_BOOKING:'guest_per_booking',
GUEST_PER_BOOKING_VALUE:7,
SEAT_ALLOCATED_VALUE:14

}